import React from 'react'

import Stack from 'react-bootstrap/Stack'

import { BackButton } from '../BackButton'
import { AccessPassCard } from '../AccessPassCard'

export default function AccessPassDetailsWrapper({
  accessPass,
  onTransferred,
}) {
  return (
    <section className="spacer-xs">
      <div className="d-flex-column flex-lg-row gap-5">
        <div className="tablet-desktop-only">
          <BackButton />
        </div>
        <Stack gap={4}>
          <AccessPassCard
            accessPass={accessPass}
            onTransferred={onTransferred}
          />
        </Stack>
      </div>
    </section>
  )
}
